import React from "react";
import {Grid} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import PaymentFileUploader from "./PaymentFileUploader";
import {usePolicyContext} from "./PolicyContext";
import PaymentFileViewer from "./PaymentFileViewer";
import {useFormikContext} from "formik";
import {ErrorCommon} from "../../formikFormInputs";
import { useSelector } from "react-redux";
import { RootState } from "../../../reducers";
import {CircularLoading as Loader} from "../../Common";
import {sleep} from "../../../utils/commonUtils";


interface AccountVerificationUpload {
    title:string, description:string, buttonTitle:string, allowFileTypes:string
}

function AccountVerificationUpload(props: AccountVerificationUpload) {
    const { title, description, buttonTitle, allowFileTypes } = props;
    const profile = useSelector((state: RootState) => state.profile);
    const fileType = "image/jpg, image/jpeg, image/png, application/pdf";
    const [loader, setLoader] = React.useState(false);
    const {policy} = usePolicyContext();
    const {values, setFieldValue, errors, touched}: any = useFormikContext();
    const clientPolicy = profile.client && profile.client.clientPolicies && profile.client.clientPolicies.length > 0 && profile.client.clientPolicies[0];
    const policyNumber = policy && policy.policyNumber || clientPolicy && clientPolicy.id;
    const setFrontPath = async (filePath: string) => {
        setLoader(true);
        await sleep(2500);
        filePath = filePath.replace(new RegExp('ToBeVoided', 'i'), ''); // hack to remove ToBeVoided after upload
        setFieldValue('checkFrontPath', filePath);
        setLoader(false);
    };

    return (
            <>
                <Grid item xs={12}>
                    <Typography variant="body1" component="strong" className="floatLeft w100 mb0">
                        {title}
                    </Typography>
                    <Typography variant="caption" className="floatLeft w100 mb0">
                        {description}
                    </Typography>
                </Grid>
                <Grid item xs={12} md={12} lg={6}>
                    {
                            !values.checkFrontPath && <>
                                <PaymentFileUploader
                                        isSecuredSignedUrl={true}
                                        fileType={allowFileTypes}
                                        dirName={policyNumber}
                                        fileName="FrontOfCheck"
                                        setFileName={setFrontPath}
                                        title={buttonTitle}
                                />
                                <ErrorCommon
                                        errors={errors}
                                        name={"checkFrontPath"}
                                        touched={touched}
                                />
                            </>
                    }
                    {
                            values.checkFrontPath &&
                            <PaymentFileViewer
                                    fileName={values.checkFrontPath}
                                    policyNumber={policyNumber}
                                    title={title}
                                    readOnly={false}
                                    deleteFile={() => {
                                        setFrontPath('');
                                    }}
                            />
                    }
                    {
                        loader && <Loader />
                    }
                </Grid>
            </>
    );
}

export default AccountVerificationUpload;